import { roles } from '@nxsys/store/constants';
import { PaymentListing, DeductionListing, VATCodeListing } from '../../../modules/paymentSetting/listing';

export const paymentsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/payments',
    element: <PaymentListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/deductions',
    element: <DeductionListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/vat-codes',
    element: <VATCodeListing />,
  },
];
